import React, { useState } from "react";
import { usePressWithoutScroll } from "../usePressWithoutScroll";

export default function FilterSection({
  title,
  icon,
  defaultOpen = false,
  children,
}) {
  const [open, setOpen] = useState(!!defaultOpen);
  const press = usePressWithoutScroll(() => setOpen((value) => !value));

  return (
    <div className="v2-drawer-section">
      <button
        type="button"
        className="v2-drawer-section-header"
        aria-expanded={open}
        onPointerDown={press.onPointerDown}
        onClick={press.onClick}
      >
        <div className="v2-drawer-section-header-left">
          {icon ? <span className="v2-drawer-section-icon">{icon}</span> : null}
          <span className="v2-drawer-section-title">{title}</span>
        </div>
        <span
          className={`v2-drawer-section-header-chevron${open ? " v2-drawer-section-header-chevron--open" : ""}`}
          aria-hidden="true"
        >
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </span>
      </button>

      {open ? (
        <div className="v2-drawer-section-body">{children}</div>
      ) : null}
    </div>
  );
}
